module.exports = __webpack_public_path__ + "img/coins-stacked-04.47b42d9f.svg";